import React from 'react';

import { serializeWhatsNewCarouselPreviewPayload } from '~/utils/societePayloadBuilder/whatsNewCarousel/buildPayload';
import type { WhatsNewCarouselPayloadBuilderState } from '~/utils/societePayloadBuilder/whatsNewCarousel/types';

import PayloadBuilderJsonPreview from '../JsonPreview';

interface WhatsNewCarouselPayloadPreviewProps {
  state: WhatsNewCarouselPayloadBuilderState;
  borderSoft: string;
  maxHeight: string;
}

export default function WhatsNewCarouselPayloadPreview({
  state,
  borderSoft,
  maxHeight,
}: WhatsNewCarouselPayloadPreviewProps) {
  return (
    <PayloadBuilderJsonPreview
      state={state}
      serialize={serializeWhatsNewCarouselPreviewPayload}
      borderSoft={borderSoft}
      maxHeight={maxHeight}
    />
  );
}
